const translation = {
  1033: 'Инвентарь',
  1034: 'Магазин',
  1530: 'У вас уже есть подписка',
  1531: 'Вы уверены, что хотите купить подписку?',
  1532: "Это будет стоить <img src='/svgs/dominion.svg' style='margin: 0px 10px -10px 10px'/> {{ param1 }}?",
  1533: "Откройте <span style='color: #FF9326;font-size: 28px'>ПЕРСОНАЛЬНЫЙ МАГАЗИН</span> </br>для своей структуры игроков",
  1534: "Аренда за <img src='/svgs/loyaltyIcon.svg' style='margin: 0px 0px -5px 2px; width: 20px'/> {{ param1 }} Loyalty Coin?",
  1535: 'Вы уверены, что хотите арендовать гексатайл #{{ param1 }}?',
  1536: "Это будет стоить <img src='/svgs/loyaltyIcon.svg' style='margin: 0px 0px -3px 2px'/> {{ param1 }} Loyalty Coin",
  1537: 'Аренда будет списываться каждые 30 дней',
  1538: 'Вы уверены, что хотите выбрать этого Советника?',
  1539: "Услуга <span style='color: #FF9326'>Territory X</span> <span style='color: #FF9326'>НЕ</span> распространяется на арендованные участки.",
  1540: 'Вы выбрали для аренды {{ param1 }} гексатайлов',
  1541: 'Требуется для аренды',
  1542: '2 года',
  1543: 'Гексатайл #{{ param1 }} арендован',
  1544: 'Вы можете увидеть его на карте во владении Советника 2',
  1545: 'Вы уверены, что хотите выбрать этого Советника?',
  1546: 'Услуга Territory X НЕ распространяется на арендованные участки.',
  1547: 'Вы уверены, что хотите разместить орб на арендованном гексатайле?',
  1548: 'Если аренда закончится, орб перестанет вам принадлежать.',
  1549: '({{ param1 }} арендовано)',
  1550: 'Арендованные гексатайлы',
  1551: 'Вы уверены, что хотите переместить / продать последний гексатайл?',
  1552: 'Если в этом Советнике не останется гексатайлов, он уйдёт в ГИБЕРНАЦИЮ. Он может оставаться пустым 7 дней, после чего будет уничтожен.',
  1553: 'В этом Советнике нет ни одного гексатайла (арендованного или купленного).',
  1554: 'Он может оставаться пустым в состоянии гибернации 7 дней, после чего будет уничтожен.',
  1555: 'Заполните Советника гексатайлами (купите или арендуйте), чтобы вывести его из гибернации.',
  1556: 'Loyalty Coin можно получить, заходя в Masters of Game каждый день и выполняя задания (скоро)',
  1557: 'Loyalty Coin — специальная монета для аренды участков земли в Legends Of Interaction. Монету может использовать только Master of Game. Loyalty Coin можно получить, заходя в Masters of Game каждый день и выполняя задания (скоро)',
  1558: '{{ param1 }} опустел и ушёл в ГИБЕРНАЦИЮ на 7 дней.',
  1559: ' Заполните его гексатайлами (купите или арендуйте), иначе он будет уничтожен.',
  1560: 'В этом Советнике нет ни одного гексатайла (арендованного или купленного).',
  1561: 'Он может оставаться пустым в состоянии гибернации 7 дней, после чего будет уничтожен.',
  1562: 'Заполните Советника гексатайлами (купите или арендуйте), чтобы вывести его из гибернации.',
  1563: 'Добро пожаловать в <br/> MASTERS OF GAME',
  1564: "Награды за <span style='color: #FF9326'>ДЕНЬ {{ param1 }}</span> :",
  1565: "Награды за <span style='color: #FF9326'>НЕДЕЛЮ</span> :",
  1566: "Награды за <span style='color: #FF9326'>МЕСЯЦ</span> :",
  1567: "<span style='color: #FF9326'>{{ param1 }}</span> гексатайлов <br/> успешно перемещено.",
  1568: "Вы можете увидеть это на карте во владении <span style='color: #FF9326'>{{ param2 }}</span>.",
  1569: 'Не активировано',
  1570: 'Вы уверены, что хотите активировать / обновить Territory X?',
  1571: 'Вы уверены, что хотите отменить эту покупку?',
  1572: "Это действие завершит торги, и информация о гексатайле вернётся на вкладку «<span style='color: #FF9326'>World</span>»",
  1573: 'Да, я хочу отменить покупку',
  1574: 'Нет, вернуться к ставкам',
  1575: 'Просматривать и размещать орбы можно только на ZOOM 19 и выше.',
  1576: "Пожалуйста, <span style='color: #FF9326'>увеличьте</span> карту.",
  1577: 'Орбы можно размещать только на купленных гексатайлах.',
  1578: 'Выберите гексатайл, который принадлежит вам.',
  1579: 'Ваши заявки на ПРОДАЖУ будут автоматически сняты через 10 дней, если не поступит предложений о покупке.',
  1580: 'Посмотрите на карте, чтобы увидеть подробности.',
  1581: 'Осталось дней: {{ param1 }}',
  1582: 'Ваша заявка на ПРОДАЖУ будет автоматически снята через 10 дней, если не поступит предложений о покупке',
  1583: "Гексатайл #{{ param1 }} продан за <img src='/svgs/reex.svg' style='margin: 0px 5px -10px 3px'/> {{ param2 }}",
  1584: 'Эта возможность доступна только участникам фокус-группы. <br/> Если вам интересно, свяжитесь с тем, кто вас сюда пригласил.',
  1585: 'Реферальные коды:',
  1586: 'Коды обновляются автоматически после активации.',
  1587: 'Недоступно',
  1600: 'Доступно: {{param1}}',
  1601: 'Нажмите, чтобы установить',
  1602: 'Приблизьте до уровня {{param1}}, чтобы установить майнер',
  1603: 'Майнеров пока нет',
  1604: 'Майнер',
  1605: 'Доступно к сбору',
  1606: 'Всего собрано',
  1607: 'Последний сбор',
  1608: 'Майнер переполнен и остановлен. Соберите REEX, чтобы он продолжил добычу',
  1609: 'Нажмите, чтобы собрать',
  1610: 'Пока нечего собирать',
  1611: 'Мои мастера',
  1612: 'Мой магазин',
  1613: 'LOI Referral',
  1614: 'Шаблоны',
  1615: 'Создать',
  1616: 'Предпросмотр',
  1617: 'Подписка',
  1618: 'Требуется подписка на магазин',
  1619: 'Для владения магазином нужна активная подписка маркетмейкера.',
  1620: 'Перейти к подписке',
  1621: 'Шаблонов пока нет',
  1622: 'Создайте первый',
  1623: 'Так ваш магазин видят покупатели',
  1624: 'Ни один шаблон не выставлен на продажу — покупатели видят пустой магазин',
  1625: 'Подписка на магазин',
  1626: 'Подписка активна',
  1627: 'Подписки нет',
  1628: 'Действует до {{param1}}',
  1629: 'Продлить или купить',
  1630: 'Купить',
  1631: '1 год',
  1632: '2 года',
  1633: '3 года',
  1634: '99 лет',
  1635: 'Купить подписку «{{param1}}» за {{param2}} {{param3}}?',
  1636: 'Оплата подписки будет доступна скоро',
  1637: 'В продаже: {{param1}}',
  1638: 'Не в продаже',
  1639: 'Предметов: {{param1}}',
  1640: 'Описание',
  1641: 'Цена',
  1642: 'В продаже: {{param1}}',
  1643: 'Не в продаже',
  1644: 'Содержимое шаблона ({{param1}})',
  1645: 'Пакет пуст.',
  1646: 'Удалить',
  1647: 'Цена (Reex)',
  1648: 'В продаже',
  1649: 'Сохранить',
  1650: 'Снять с продажи',
  1651: 'Создать шаблон',
  1652: 'Орбы',
  1653: 'Монеты',
  1654: 'Здесь пусто',
  1655: 'Изображение шаблона',
  1656: 'Загрузить изображение',
  1657: 'Изменить изображение',
  1658: 'Название шаблона',
  1659: 'В шаблоне ({{param1}})',
  1660: 'Отмена',
  1661: 'Создание...',
  1662: 'Слишком много',
  1663: 'Предложений пока нет',
  1664: 'Покупка недоступна',
  1665: 'Вы маркетмейкер.',
  1666: 'Осталось: {{param1}}',
  1667: 'Продавец',
  1668: 'Цена за пакет',
  1669: 'Содержимое пакета ({{param1}})',
  1670: 'Нет данных о содержимом.',
  1671: 'Количество',
  1672: 'Итого',
  1673: 'Предпросмотр — покупка недоступна',
  1674: 'Куплено: {{param1}} ×{{param2}}',
  1675: 'Купить «{{param1}}» ×{{param2}} за {{param3}} Reex?',
  1676: 'Присоединения:',
  1677: 'Количество (± в продаже)',
  1678: 'Добавить в продажу',
  1679: 'Выставить на продажу',
  1680: 'Награда получена',
  1681: 'Собрано: {{param1}} REEX',
  1682: 'С',
  1683: 'По',
  1684: 'Показать',
  1685: 'Экспорт CSV',
  1686: 'Ресурс',
  1687: 'Транзакции',
  1688: 'Отчёт',
  1689: '{{param1}} год',
  1690: '{{param1}} лет',
  1691: 'Срок будет добавлен к текущей дате окончания.',
  1692: 'После этой покупки вы станете маркетмейкером и будете выведены из текущей структуры.',
  1693: 'Купить Dominion',
  1694: 'КОЛИЧЕСТВО',
  1695: 'ВАЛЮТА ОПЛАТЫ',
  1696: 'Скоро',
  1697: 'Баланс: {{param1}}',
  1698: 'Криптовалюта',
  1699: 'Сеть {{param1}}',
  1700: 'Итого:',
  1701: 'НЕДОСТАТОЧНО {{param1}}',
  1702: 'КУПИТЬ {{param1}} {{param2}}',
  1703: 'Курс: {{param1}} REEX за 1 {{param2}}. Другие способы оплаты появятся позже.',
  1704: 'Куплено {{param1}} {{param2}}',
  1705: 'Купить {{param1}} {{param2}} за {{param3}}?',
  1706: 'Персональные предложения',
  1707: 'Специальная цена на определённое количество пакетов для конкретного игрока из вашей структуры. Персональные предложения применяются раньше обычной цены и исчезают, когда заканчиваются.',
  1708: 'Игрок',
  1709: 'Для этого шаблона нет персональных предложений',
  1710: 'Добавить',
  1711: 'Удалить персональное предложение для {{param1}}?',
  1712: 'Персональная цена',
  1713: 'Персональная цена на первые {{param1}} пакетов',
  1714: '{{param1}} по персональной цене, {{param2}} по обычной',
  1715: 'Продажа',
  1716: 'Игрок #{{param1}}',
  1717: 'Персональных: {{param1}}',
  1718: 'Загрузка курса…',
  1719: 'Не удалось загрузить курс. Покупка временно недоступна.',
  1720: 'Повторить',
  1721: 'КУРС НЕДОСТУПЕН',
  1722: 'Реферальная ссылка',
  1723: 'Получить мастеров',
  1724: 'Мастеров Игры',
  1725: 'В данном разделе можно будет делать заказ на получение Мастеров Игры через глобальные рекламные кампании. Для оформления заказа необходимо прислать специальный токен 1GM на ваш внутренний адрес для приема ресурсов. Если вы хотите узнать больше про 1GM, обратитесь к вашим вышестоящим Маркетмейкерам.',
  1726: 'Бессрочная',
  1727: 'Действует бессрочно',
  1728: 'У вас бессрочная подписка — покупать больше нечего.',
  1729: 'Получите личных Мастеров Игры через глобальную рекламную кампанию',
  1730: 'Вы можете заказать для себя регистрацию',
  1731: 'Заказать',
  1732: 'Возможность заказывать регистрацию Мастеров Игры будет включена позже.',
  1733: 'Приблизьте до уровня {{param1}}, чтобы перемещать орбы',
  1734: '1GM — специальный токен для заказа регистрации Мастеров Игры через глобальные рекламные кампании. Чтобы узнать больше про 1GM, обратитесь к вашим вышестоящим Маркетмейкерам.',
  1735: 'ПОДДЕРЖКА',
  1736: 'Новый тикет',
  1737: 'Тема',
  1738: 'Сообщение',
  1739: 'Создать тикет',
  1740: 'У вас пока нет тикетов',
  1741: 'Назад к тикетам',
  1742: 'Напишите ответ',
  1743: 'Ответить',
  1744: 'Открыт',
  1745: 'Закрыт',
  1746: 'Поддержка',
  1747: 'Вы',
  1748: 'Тикет закрыт, отвечать больше нельзя.',
  1749: 'Отмена',
  1750: 'В этом тикете пока нет сообщений',
  1751: 'Отвечено',
  1752: 'ORB',
  1753: 'R-ORB',
  1754: 'R-ORB MAP',
  1755: 'REEX MINER',
  1756: 'Предмет',
  1757: 'Этот раздел доступен только маркетмейкерам',
  1758: 'Попадание по дрону даёт {{param1}} Loyalty coins. Каждый выстрел стоит {{param2}} Loyalty coin.',
  1759: 'Зарегистрируйтесь, чтобы участвовать',
  1760: 'Пополните баланс, чтобы продолжить',
  1761: 'Пополнить',
  1762: 'Цена в других валютах',
  1763: 'Для сбора нужно накопить минимум {{param1}} REEX',
  1764: 'Пульс',
  1765: 'Пульс магазина',
  1766: 'Оборот и всё, что его объясняет. Экран отвечает на вопрос «зачем я плачу за подписку».',
  1767: 'ОБОРОТ ЗА ПОСЛЕДНИЙ МЕСЯЦ',
  1768: 'Продаж: {{param1}}',
  1769: 'ВАШЕ МЕСТО',
  1770: 'из {{param1}} магазинов за последний месяц',
  1771: 'за последний месяц продаж не было',
  1772: 'ПУСТЫЕ ЗЕМЛИ',
  1773: 'участки Ваших мастеров без единого объекта',
  1776: 'ЁМКОСТЬ',
  1777: 'столько пакетов выставлено прямо сейчас',
  1785: 'Мастера с пустыми землями',
  1787: 'Аналитика появится, когда сервер начнёт её отдавать',
  1790: 'Данных пока нет',
  1793: 'пустых {{param1}} из {{param2}} участков',
  1794: 'Все земли Ваших мастеров застроены',
  1795: 'Рейтинг продаж за последний месяц',
  1796: 'анонимный рейтинг всех магазинов по продажам за период',
  1797: 'Ваш магазин',
  1798: 'Мои данные',
  1799: 'Рейтинг',
  1800: 'Можно выставить: {{param1}}',
  1801: 'Максимум {{param1}} при текущих активах',
  1802: 'Активов не хватает, чтобы выставить больше',
  1803: 'Магазин',
  1804: 'Мои заявки',
  1805: 'Заявки',
  1806: 'Сообщите Вашему маркетмейкеру, что Вам нужно',
  1807: 'Новая заявка',
  1808: '{{param1}} из {{param2}} заявок',
  1809: 'Заявок пока нет',
  1810: 'Пакетов: {{param1}}',
  1811: '{{param1}} Reex за пакет',
  1812: 'Итого: {{param1}} Reex',
  1813: 'Выберите, что хотите купить',
  1814: 'В заявке ({{param1}})',
  1815: 'Пока ничего не выбрано',
  1816: 'Количество пакетов',
  1817: 'Цена за пакет (Reex)',
  1818: 'Создать заявку',
  1819: 'Заявки от Ваших мастеров',
  1820: 'Ваши мастера пока ничего не запрашивали',
  1821: 'Закрыть заявку',
  1822: 'Лимит достигнут: удалите заявку, чтобы создать новую',
  1823: 'Нет ресурсов, доступных для заявки',
  1824: 'Что хотят купить Ваши мастера. Закройте заявку, когда она выполнена.',
  1825: 'Игра в ранней бете',
  1826: 'Legends of Interactions находится на ранней стадии разработки. Функции и контент ещё добавляются и могут меняться от версии к версии.',
  1827: 'Актуальную версию игры можно скачать на официальном сайте',
  1828: 'Скачать игру',
  1829: 'Пригласительные коды в LOI',
  1830: 'НАКОПЛЕНО',
  1831: 'Нажмите на орб, чтобы собрать',
  1832: 'Пока ничего не накопилось',
  1833: 'Дополнительно',
  1834: 'Особые функции игры',
  1835: 'Эмуляторы игроков',
  1836: 'Привяжите эмулятор к советнику, и он будет собирать ресурсы с орбов за Вас.',
  1837: 'СВОБОДНЫЕ ЭМУЛЯТОРЫ',
  1838: 'Привязать эмулятор',
  1839: 'Активен',
  1842: 'Свободных эмуляторов нет',
  1843: 'Привязать эмулятор к советнику «{{param1}}»?',
  1844: 'Эмулятор начнёт собирать ресурсы для этого советника.',
  1847: 'У Вас пока нет советников',
  1848: 'Гексов: {{param1}} / {{param2}}',
  1851: 'Главный',
  1852: 'Активен с {{param1}}',
  1853: 'БАТАРЕЯ',
  1854: 'Вернуть в инвентарь',
  1855: 'Вернуть эмулятор советника «{{param1}}» в инвентарь?',
  1856: 'Эмулятор перестанет собирать ресурсы и снова станет свободным.',
}

export default translation
